module.exports = __webpack_public_path__ + "img/dente inf-04.ca5c7ae0.svg";